import script from "./AlignmentButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./AlignmentButtons.vue?vue&type=script&setup=true&lang=js"

import "./AlignmentButtons.vue?vue&type=style&index=0&id=6b1f591f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b1f591f"]])

export default __exports__